import { render, staticRenderFns } from "./APhotoGallery.vue?vue&type=template&id=5a5508d8&scoped=true"
import script from "./APhotoGallery.vue?vue&type=script&lang=js"
export * from "./APhotoGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5508d8",
  null
  
)

export default component.exports